import { buildRequestInit } from '@datocms/cda-client'
import { queryArticles } from '~/graphql/queries'

// TODO: Merge FetchOptions w/ DatocmsOptions
type Options<Variables> = {
  options?: Options<Variables>
}

export function useArticles<Variables>(options?: Options<Variables>) {
  const config = useRuntimeConfig()
  const draftMode = useDraftMode()

  /*
   * Depending on whether the Draft Mode is active or not, we use an API token
   * with different permissions
   */
  const apiToken = draftMode
    ? // If Draft mode is ON, then we use the token saved in the cookie, which (if
      // not forged) allows us to access the contents in draft
      draftMode.datocmsDraftContentCdaToken
    : // Otherwise, we use the token to access the published content. Given that
      // this token does not expose sensitive information, it is also accessible
      // on the client side.
      config.public.datocmsPublishedContentCdaToken

  if (!apiToken) {
    throw new Error('Missing API token')
  }

  const environmentId = config.public.datocmsEnvironmentId

  return $fetch('https://graphql.datocms.com/', {
    ...buildRequestInit(queryArticles, {
      token: apiToken,
      variables: options?.variables,
      includeDrafts: config.public.environment !== 'production' || Boolean(draftMode),
      excludeInvalid: true,
      environment: environmentId
    })
  })
}
